import React from "react";
import FooterTitle from "./FooterTitle";
import IcoLocation from "../svg/IcoLocation";
import IcoPhone from "../svg/IcoPhone";
// import IcoLinkedin from "../svg/IcoLinkedin";
import IcoFacebook from "../svg/IcoFacebook";

export default function Footer() {
  return (
    <div className="bg-primary py-16 lg:pl-[404px] lg:pr-10 px-5 flex text-white gap-x-6 flex-wrap gap-y-10 relative">
      <div className="lg:max-w-96 w-full lg:w-fit">
        <FooterTitle title="Qui sommes-nous ?" />

        <p className="mt-10 text-white text-sm font-normal leading-snug">
          La societe Pro Distribution Automatismes existe depuis 1996. <br />
          <br /> Elle doit sa longévité à la qualité de nos produits et à
          l’importance que nous accordons au service et au suivi de nos clients
        </p>
      </div>

      <div className="max-w-96 w-full pt-10 lg:w-fit lg:pt-0">
        <FooterTitle title="Comment pouvons-nous vous aider ?" />

        <p className="mt-10 text-white text-sm font-normal leading-snug">
          <b>Nos horaires d’ouverture :</b> <br />
          lundi au jeudi de 08h00 à 12h00 et de 13h30 à 17h30 vendredi de 08h00
          à 12h00 et de 13h30 à 16h30
        </p>

        <div className="flex gap-x-3 mt-5">
          <div className=" h-6 w-6 pt-1.5 text-white flex justify-center items-center">
            <IcoLocation />
          </div>
          <div>
            5, rue des frères Michelin <br />
            10600 La-Chapelle-Saint-Luc
          </div>
        </div>

        <div className="flex gap-x-3 mt-5">
          <div className=" h-6 w-6 pt-1.5 text-white flex justify-center items-center">
            <IcoPhone />
          </div>
          <div>03&nbsp;25&nbsp;71&nbsp;98&nbsp;26</div>
        </div>
      </div>

      <div className="max-w-96 w-full  pt-10 lg:w-fit lg:pt-0">
        <FooterTitle title="Restons en contact" />

        <div className="mt-10 flex gap-x-[14px]">
          {/* <a
            className="h-[26px] w-[26px] flex justify-center items-center"
            href="/"
            target="_blank"
            rel="noreferrer"
          >
            <IcoLinkedin />
          </a> */}
          <a
            className="h-[26px] w-[26px] flex justify-center items-center"
            href="https://www.facebook.com/prodistributionautomatismes?locale=fr_FR"
            target="_blank"
            rel="noreferrer"
          >
            <IcoFacebook />
          </a>
        </div>
      </div>

      <div className="absolute bottom-2.5 right-2.5 text-white opacity-30">
        v{process.env.REACT_APP_VERSION}
      </div>
    </div>
  );
}
